export default function SchedulerPlanningProgressBar({ runProgress }) {
  const isActive = Boolean(runProgress?.active);

  if (!isActive) {
    return null;
  }

  const percent = Math.max(0, Math.min(100, Number(runProgress?.percent) || 0));
  const label = runProgress?.current_label || 'Working...';

  return (
    <div className="mt-1.5 border-t border-gray-950/5 px-2 pb-1.5 pt-1.5">
      <div className="flex items-center justify-between gap-2">
        <p className="min-w-0 truncate text-[10px] font-medium text-dashboard-stats-info">
          {label}
        </p>
        <span className="flex-shrink-0 text-[10px] font-bold tabular-nums text-dashboard-stats-primary">
          {Math.round(percent)}%
        </span>
      </div>
      <div className="mt-1 h-1 overflow-hidden rounded-full bg-dashboard-stats-primary-dark/30">
        <div
          className="h-full rounded-full bg-main-primary"
          style={{
            width: `${percent}%`,
            transition: 'width 400ms ease-out',
          }}
        />
      </div>
    </div>
  );
}
